<template>
  <div>
    <PageHeader :schema="$schemas.box" />
    <PageContent>
      <DynamicFormPage :schema="$schemas.box" :service="$api.boxes" />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicFormPage from '@/components/dynamics/DynamicFormPage';

export default {
  name: 'CreateBox',
  components: { PageHeader, PageContent, DynamicFormPage },
};
</script>
